import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=1fbae930&scoped=true&"
import script from "./QuestionDetail.vue?vue&type=script&lang=ts&"
export * from "./QuestionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=1fbae930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbae930",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VRadio,VRadioGroup,VSelect,VSimpleTable,VTextField,VTextarea})
